import { Building2, ChevronDown, Loader as Loader2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useCompany } from '@/context/CompanyContext';

export function CompanySelector() {
  const { companies, activeCompanyId, loadingCompanies } = useCompany();
  const navigate = useNavigate();

  if (loadingCompanies) {
    return (
      <div className="flex items-center gap-2 px-3 py-1.5 text-sm text-gray-500">
        <Loader2 className="w-4 h-4 animate-spin" />
        <span>טוען חברות...</span>
      </div>
    );
  }

  const active = companies.find(c => c.id === activeCompanyId);
  if (!active) return null;

  // Single company — plain label, no action needed
  if (companies.length === 1) {
    return (
      <div className="flex items-center gap-2 px-3 py-1.5 bg-primary-50 border border-primary-200 rounded-lg">
        <Building2 className="w-4 h-4 text-primary-600 flex-shrink-0" />
        <span className="text-sm font-medium text-primary-800 max-w-[200px] truncate">
          {active.legal_name}
        </span>
      </div>
    );
  }

  // Multiple companies — button that navigates to /workspaces for clean company switch
  return (
    <button
      onClick={() => navigate('/workspaces')}
      className="flex items-center gap-2 px-3 py-1.5 bg-primary-50 border border-primary-200 rounded-lg hover:bg-primary-100 transition-colors"
      title="החלף חברה"
    >
      <Building2 className="w-4 h-4 text-primary-600 flex-shrink-0" />
      <span className="text-sm font-medium text-primary-800 max-w-[200px] truncate">
        {active.legal_name}
      </span>
      <ChevronDown className="w-3.5 h-3.5 text-primary-500 flex-shrink-0" />
    </button>
  );
}
